import React from 'react';
import PropTypes from 'prop-types';
import Image from '@nubank/nuds-web/components/Image/Image';
import Box from '@nubank/nuds-web/components/Box/Box';

const ContractImage = ({ data }) => (
  <Box marginVertical="16x">
    <Image
      alt="image"
      src={data.url}
      width="auto"
    />
  </Box>
);

ContractImage.propTypes = {
  data: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }).isRequired,
};

export default ContractImage;
